import { useRef, FormEvent, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/ContactButton.css'


const ContactButton = () => {
  const form = useRef<any>();
  const [showModal, setShowModal] = useState<boolean>();

  const sendEmail = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    emailjs.sendForm('service_5l7m8zs', 'template_486ly2k', form.current, {
        publicKey: '1qNofqne3JPd2o4jz',
      });
  };

  return (<>
      <footer>
        <button type='button' onClick={() => setShowModal(true)}>Contactános</button>
      </footer>
      {showModal &&
        <div className="modal">
          <div className='modal-content'>
            <span className="close" onClick={() => setShowModal(false)}>&times;</span>
            <h2>Dejanos tu comentario</h2>
            <form ref={form} onSubmit={(e) => sendEmail(e)}>
              <div>
                <label>Nombre</label>
                <input type="text" name="from_name" />  
              </div>
              <div>
                <label>Email</label>
                <input type="email" name="from_email" />
              </div>
              <label>Mensaje</label>
              <textarea name="message" />
              <button type="submit" value="Send">Enviar</button>
            </form>
          </div>
        </div>
      }
    </>
  );
  
}

export default ContactButton
